"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CatalogLoading_1 = __importDefault(require("./CatalogLoading"));
exports.default = CatalogLoading_1.default;
